import { NewTag } from "@/components/Tag";
import { BREAKPOINTS } from "@/settings";
import { useMediaQuery } from "usehooks-ts";

import { convertSBCPrice } from "../../../../functions/convertPlayerPrice";
import { Platform } from "../../../../redux/user/userSlice";
import { PlatformChoice } from "../PlatformChoice/PlatformChoice";

type Props = {
  pcPrice: number;
  psPrice: number;
  remainingCost: number | null;
  platform: Platform;
  isNew: boolean;
  hasRefreshed: boolean;
};

export const SetHeaderSubtitle = ({
  pcPrice,
  psPrice,
  remainingCost,
  platform,
  isNew,
  hasRefreshed,
}: Props) => {
  const isTouchDevice = useMediaQuery(BREAKPOINTS.TOUCH_DEVICE.query);
  return (
    <div className="flex flex-col mobile:flex-row gap-x-1">
      <div className="flex flex-row gap-x-1">
        <img
          className="w-4 h-4 my-auto"
          src={`${
            import.meta.env.VITE_APP_ASSETS_BASE_URL
          }/fc24/misc/fc24coin.png`}
          alt="fut-coin"
        />
        <p className="my-auto text-base text-dark-primary font-medium">
          {convertSBCPrice(platform === "PC" ? pcPrice : psPrice)}
        </p>
        <div className="my-auto">
          <PlatformChoice platform={platform} />
        </div>
        {(isNew || hasRefreshed) && !isTouchDevice && (
          <NewTag type="new-design" tag={isNew ? "NEW" : "REFRESHED"} />
        )}
      </div>
      {remainingCost > 0 && (
        <span className="text-sm desktop:text-base text-white/50">
          ({convertSBCPrice(remainingCost)} remaining)
        </span>
      )}
    </div>
  );
};
